import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSort,
  MatPaginator,
  MatTable
} from '@angular/material';
import { LocationService } from 'src/app/_service/location.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import 'url-search-params-polyfill';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-edit-site',
  templateUrl: './edit-site.component.html',
  styleUrls: ['./edit-site.component.css']
})
export class EditSiteComponent implements OnInit {

  isLoading = false;
  authorities;
  authArray: any[];
  selectedAuthority;
  newSiteName;
  authority: any = [];
  allAuthorities: any = [];
  MyDataSource: any;
  locationDetailArray: any = [];
  locationModel: any = [];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatTable, { static: false }) table: MatTable<any>;

  editSiteForm: FormGroup;

  confirmModal = false;
  deleteLocationID: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private locationService: LocationService,
    private alertify: AlertifyService,
    public dialog: MatDialog,
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<EditSiteComponent>,
  ) 
  {
    this.editSiteForm = fb.group({
      siteFormControl : new FormControl('', [
        // this.WhitespaceValidator
      ]),
      siteAliasFormControl: new FormControl('', [
      ]).clearValidators(),
      serviceAreaFormControl : new FormControl('', [
        // this.WhitespaceValidator
      ]),
      serviceAreaAliasFormControl : new FormControl('', [
      ]).clearValidators(),

      locationFormControl : new FormControl('', [
        // this.WhitespaceValidator
      ]),
      locationAliasFormControl : new FormControl('', [
      ]).clearValidators(),

      subLocationFormControl : new FormControl('', [
        // this.WhitespaceValidator
      ]),
      subLocationAliasFormControl : new FormControl('', [
      ]).clearValidators(),

      departmentFormControl : new FormControl('', [
        // this.WhitespaceValidator
      ]),
      departmentAliasFormControl : new FormControl('', [
      ]).clearValidators(),

      subdepartmentFormControl : new FormControl('', [
        // this.WhitespaceValidator
      ]),
      subdepartmentAliasFormControl : new FormControl('', [
      ]).clearValidators()
    });
  }

  topLevelId = this.passedData.authority.topLevelId;
  topLevelName = this.passedData.authority.topLevelName;
  subTopLevelId = this.passedData.authority.subTopLevelId;
  subTopLevelName = this.passedData.authority.subTopLevelName;
  hospitalLevelId = this.passedData.authority.hospitalLevelId;
  hospitalLevelName = this.passedData.authority.hospitalLevelName;
  departmentLevelId = this.passedData.authority.departmentLevelId;
  departmentLevelName = this.passedData.authority.departmentLevelName;
  departmentLevelChildId = this.passedData.authority.departmentLevelChildId;
  departmentLevelChildName = this.passedData.authority.departmentLevelChildName;
  floorLevelId = this.passedData.authority.floorLevelId;
  floorLevelName = this.passedData.authority.floorLevelName;

  is_edit: boolean;

  locationDetail: any = [];
  authorityLevel: any;
  authorityLevelAliasId: any;
  authorityLevelAlias: any = [];
  siteLevel: any;
  siteLevelAliasId: any;
  siteLevelAlias: any = [];
  locationLevel: any;
  locationLevelAliasId: any;
  locationLevelAlias: any = [];
  departmentLevel: any;
  departmentLevelAliasId: any;
  departmentLevelAlias: any = [];
  subDepartmentLevel: any;
  subDepartmentLevelAliasId: any;
  subDepartmentLevelAlias: any = [];
  floorLevel: any;
  floorLevelAliasId: any;
  floorLevelAlias: any = [];

  locationChildExists: any;
  allLocationsDeleted: any;

  siteConfirmationMessage: any = {};
  serviceAreaConfirmationMessage: any = {};

  locationNotUpdated: any ={};

  locationWhiteSpaceValidation: any;
  loading = false;

  locationNameExists: any = {};
  floorNameExists: any = {};
  departmentLevelChildNameExists: any = {};
  departmentLevelNameExists: any = {};
  hospitalLevelNameExists: any = {};
  subTopLevelNameExists: any = {};
  topLevelNameExists: any = {};

  model = {
    topLevelId: this.topLevelId,
    topLevelName: this.topLevelName,
    subTopLevelId: this.subTopLevelId,
    subTopLevelName: this.subTopLevelName,
    hospitalLevelId: this.hospitalLevelId,
    hospitalLevelName: this.hospitalLevelName,
    departmentLevelId: this.departmentLevelId,
    departmentLevelName: this.departmentLevelName,
    departmentLevelChildId: this.departmentLevelChildId,
    departmentLevelChildName: this.departmentLevelChildName,
    floorLevelId: this.floorLevelId,
    floorLevelName: this.floorLevelName,

    topLevelAliasId: '',
    topLevelAlias: '',
    subTopLevelAliasId: '',
    subTopLevelAlias: '',
    hospitalLevelAliasId: '',
    hospitalLevelAlias: '',
    departmentLevelAliasId: '',
    departmentLevelAlias: '',
    departmentLevelChildAliasId: '',
    departmentLevelChildAlias: '',
    floorLevelAliasId: '',
    floorLevelAlias: ''
  };

  Id: number;
  deleteModel: any = {};
  isModified = false;
  isParentDeleted = false;

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    console.log(control.value);
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}

public locationValidator() {
  if (this.authorityLevel !== undefined || this.siteLevel !== undefined || this.locationLevel !== undefined 
    || this.departmentLevel !== undefined || this.subDepartmentLevel !== undefined || this.floorLevel !== undefined) {
      this.editSiteForm.controls.siteFormControl.setValidators([Validators.required, this.WhitespaceValidator]);
      this.editSiteForm.controls.serviceAreaFormControl.setValidators([Validators.required, this.WhitespaceValidator]);
      this.editSiteForm.controls.locationFormControl.setValidators([Validators.required, this.WhitespaceValidator]);
      this.editSiteForm.controls.subLocationFormControl.setValidators([Validators.required, this.WhitespaceValidator]);
      this.editSiteForm.controls.departmentFormControl.setValidators([Validators.required, this.WhitespaceValidator]);
      this.editSiteForm.controls.subdepartmentFormControl.setValidators([Validators.required, this.WhitespaceValidator]);
      return false;
    } else {
      this.editSiteForm.controls.siteFormControl.setValidators(null);
      this.editSiteForm.controls.serviceAreaFormControl.setValidators(null);
      this.editSiteForm.controls.locationFormControl.setValidators(null);
      this.editSiteForm.controls.subLocationFormControl.setValidators(null);
      this.editSiteForm.controls.departmentFormControl.setValidators(null);
      this.editSiteForm.controls.subdepartmentFormControl.setValidators(null);
      return true;
    }
}

  ngOnInit() {
    this.getLocationDetail();
  }

  getLocationDetail() {
    const params = new URLSearchParams();
    if (this.topLevelId !== 0) {
      this.locationModel.push(this.topLevelId);
    }
    if (this.subTopLevelId !== 0) {
      this.locationModel.push(this.subTopLevelId);
    }
    if (this.hospitalLevelId !== 0) {
      this.locationModel.push(this.hospitalLevelId);
    }
    if (this.departmentLevelId !== 0) {
      this.locationModel.push(this.departmentLevelId);
    }
    if (this.departmentLevelChildId !== 0) {
      this.locationModel.push(this.departmentLevelChildId);
    }
    if (this.floorLevelId !== 0) {
      this.locationModel.push(this.floorLevelId);
    }

    return this.locationService.getLocationDetail(this.locationModel).subscribe(
      res => {
        this.locationDetail = res.body;
        console.log(this.locationDetail);
        // location
        this.authorityLevel = this.locationDetail[0];
        // alias
        if (this.authorityLevel !== undefined) {
          for (const authLevelAlias of this.locationDetail[0].locationAlias) {
            this.authorityLevelAliasId = authLevelAlias.locationAliasId;
            this.authorityLevelAlias = authLevelAlias.locationAliasName; //
            // console.log(this.authorityLevelAliasId + ' ' + this.authorityLevelAlias);
          }
        }
        // location
        this.siteLevel = this.locationDetail[1];
        // alias
        if (this.siteLevel !== undefined) {
          for (const siteLevelAlias of this.locationDetail[1].locationAlias) {
            this.siteLevelAliasId = siteLevelAlias.locationAliasId;
            this.siteLevelAlias = siteLevelAlias.locationAliasName;
            // console.log(this.siteLevelAliasId + ' ' + this.siteLevelAlias);
          }
        }
        // location
        this.locationLevel = this.locationDetail[2];
        // alias
        if (this.locationLevel !== undefined) {
          for (const locationAlias of this.locationDetail[2].locationAlias) {
            this.locationLevelAliasId = locationAlias.locationAliasId;
            this.locationLevelAlias = locationAlias.locationAliasName; //
            console.log(this.locationLevelAliasId + ' ' + this.locationLevelAlias);
          }
        }
        // location
        this.departmentLevel = this.locationDetail[3];
        // alias
        if (this.departmentLevel !== undefined) {
          for (const departmentAlias of this.locationDetail[3].locationAlias) {
            this.departmentLevelAliasId = departmentAlias.locationAliasId;
            this.departmentLevelAlias = departmentAlias.locationAliasName; //
            console.log(this.departmentLevelAliasId + ' ' + this.departmentLevelAlias);
          }
        }
        // location
        this.subDepartmentLevel = this.locationDetail[4];
        // alias
        if (this.subDepartmentLevel !== undefined) {
          for (const subDepartmentAlias of this.locationDetail[4].locationAlias) {
            this.subDepartmentLevelAliasId = subDepartmentAlias.locationAliasId;
            this.subDepartmentLevelAlias = subDepartmentAlias.locationAliasName;
            console.log(this.subDepartmentLevelAliasId + ' ' + this.subDepartmentLevelAlias);
          }
        }
        // location
        this.floorLevel = this.locationDetail[5];
        // alias
        if (this.floorLevel !== undefined) {
        for (const floorAlias of this.locationDetail[5].locationAlias) {
          this.floorLevelAliasId = floorAlias.locationAliasId;
          this.floorLevelAlias = floorAlias.locationAliasName;
          console.log(this.floorLevelAliasId + ' ' + this.floorLevelAlias);
        }
      }
      }
    );
  }

removeSelectedLocation(id) {
  this.confirmModal = true;
  this.deleteLocationID = id;
}

dontDeleteLocation() {
  this.confirmModal = false;
}

  deleteSite(id) {
    this.locationService.removeLocation(id).subscribe(
      res => {
        this.locationChildExists = res.headers.get('childlocationsexist');
        this.allLocationsDeleted = res.headers.get('locationsdeleted');
        if (this.allLocationsDeleted) {
          this.isParentDeleted = true;
          this.dialog.closeAll();
        }
        if (this.locationChildExists) {
          this.alertify.message(this.locationChildExists);
        } else {
          this.alertify.success('Location successfully deleted');
          this.confirmModal = false;
          this.isModified = true;
          this.getLocationDetail();
        }
      },
      error => {
        this.alertify.error('Something went wrong, please try again');
      });
  }

  updateSite() {
    if (this.topLevelId === 0 || this.authorityLevel === undefined) {
      this.model.topLevelId = null;
      this.model.topLevelName = null;

      this.model.topLevelAliasId = '0';
      this.model.topLevelAlias = null;
    }
    // update site name
    this.model.topLevelId = this.topLevelId;
    this.model.topLevelName = this.authorityLevel.locationName.trim();

    // update site alias name
    if (this.authorityLevelAlias.length === 0) {
      this.model.topLevelAliasId = this.authorityLevelAliasId;
      this.model.topLevelAlias = '';
    } else {
      this.model.topLevelAliasId = this.authorityLevelAliasId;
      this.model.topLevelAlias = this.authorityLevelAlias.trim();
    }

    if (this.subTopLevelId === 0 || this.siteLevel === undefined) {
      this.model.subTopLevelId = null;
      this.model.subTopLevelName = null;

      this.model.subTopLevelAliasId = '0';
      this.model.subTopLevelAlias = null;
    } else {
      this.model.subTopLevelName = this.siteLevel.locationName.trim();

      if (this.siteLevelAlias.length === 0) {
        this.model.subTopLevelAliasId = this.siteLevelAliasId;
        this.model.subTopLevelAlias = '';
      } else {
        this.model.subTopLevelAliasId = this.siteLevelAliasId;
        this.model.subTopLevelAlias = this.siteLevelAlias.trim();
      }
    }
    if (this.hospitalLevelId === 0 || this.locationLevel === undefined) {
      this.model.hospitalLevelId = null;
      this.model.hospitalLevelName = null;

      this.model.hospitalLevelAliasId = '0';
      this.model.hospitalLevelAlias = null;
    } else {
      this.model.hospitalLevelName = this.locationLevel.locationName.trim();

      if (this.locationLevelAlias.length === 0) {
        this.model.hospitalLevelAliasId = this.locationLevelAliasId;
        this.model.hospitalLevelAlias = '';
      } else {
        this.model.hospitalLevelAliasId = this.locationLevelAliasId;
        this.model.hospitalLevelAlias = this.locationLevelAlias.trim();
      }
     }
      if (this.departmentLevelId === 0 || this.departmentLevel === undefined) {
      this.model.departmentLevelId = null;
      this.model.departmentLevelName = null;

      this.model.departmentLevelAliasId = '0';
      this.model.departmentLevelAlias = null;
    } else {
      this.model.departmentLevelName = this.departmentLevel.locationName.trim();

      if (this.departmentLevelAlias.length === 0) {
        this.model.departmentLevelAliasId = this.departmentLevelAliasId;
        this.model.departmentLevelAlias = '';
      } else {
        this.model.departmentLevelAliasId = this.departmentLevelAliasId;
        this.model.departmentLevelAlias = this.departmentLevelAlias.trim();
      }
    }
    if (this.departmentLevelChildId === 0 || this.subDepartmentLevel === undefined) {
      this.model.departmentLevelChildId = null;
      this.model.departmentLevelChildName = null;

      this.model.departmentLevelChildAliasId = '0';
      this.model.departmentLevelChildAlias = null;
    } else {
      this.model.departmentLevelChildName = this.subDepartmentLevel.locationName.trim();

      if (this.subDepartmentLevelAlias.length === 0) {
        this.model.departmentLevelChildAliasId = this.subDepartmentLevelAliasId;
        this.model.departmentLevelChildAlias = '';
      } else {
        this.model.departmentLevelChildAliasId = this.subDepartmentLevelAliasId;
        this.model.departmentLevelChildAlias = this.subDepartmentLevelAlias.trim();
      }
    }
    if (this.floorLevelId === 0 || this.floorLevel === undefined) {
      this.model.floorLevelId = null;
      this.model.floorLevelName = null;

      this.model.floorLevelAliasId = '0';
      this.model.floorLevelAlias = null;
    } else {
      this.model.floorLevelName = this.floorLevel.locationName.trim();

      if (this.floorLevelAlias.length === 0) {
        this.model.floorLevelAliasId = this.floorLevelAliasId;
        this.model.floorLevelAlias = '';
      } else {
        this.model.floorLevelAliasId = this.floorLevelAliasId;
        this.model.floorLevelAlias = this.floorLevelAlias.trim();
      }
    }

    this.loading = true;
    return this.locationService.updateLocations(this.model).subscribe(
      res => {
        this.locationNameExists = res.headers.get('locationnameexists');
        if (this.locationNameExists) {
          this.loading = false;
          this.alertify.error(this.locationNameExists);
        }
        this.topLevelNameExists = res.headers.get('toplevelnameexists');
        if (this.topLevelNameExists) {
          this.loading = false;
          this.alertify.error(this.topLevelNameExists);
        }
        this.siteConfirmationMessage = res.headers.get('locationupdated');
        if (this.siteConfirmationMessage) {
          this.alertify.success(this.siteConfirmationMessage);
          this.loading = false;
          this.isModified = true;
        }
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.alertify.error('Something went wrong, please try again');
      }
    );
  }
}
